import { pr } from '@/utils/pxToRem';
import { Grid, Stack, Typography } from '@mui/material';
import React from 'react';

const SectionWhyBookUs = () => (
  <Grid
    container
    spacing={pr`27px`}
    marginTop={pr`16px`}
  >
    <Grid
      item
      xs={12}
      md={4}
    >
      <Stack
        spacing={pr`4px`}
        textAlign="center"
        alignItems="center"
      >
        <img
          src="https://storage.googleapis.com/goyolo-production/phuong-tien.png"
          alt="logo"
          className="lazyload"
          style={{
            width: '150px',
          }}
        />
        <Typography variant="body1">Tất cả phương tiện trong một</Typography>
        <Typography variant="caption">
          Goyolo.com là nền tảng đặt vé đầu tiên ở Việt Nam cho phép người dùng so
          sánh giá cả, giờ khởi hành, tổng thời gian di chuyển, đánh giá chất
          lượng giữa máy bay, xe khách, xe lửa trên cùng 1 màn hình
        </Typography>
      </Stack>

    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Stack
        spacing={pr`4px`}
        textAlign="center"
        alignItems="center"
      >
        <img
          src="https://storage.googleapis.com/goyolo-production/co-ve.png"
          alt="logo"
          className="lazyload"
          style={{
            width: '150px',
          }}
        />
        <Typography variant="body1">Chắc chắn có vé</Typography>
        <Typography variant="caption">
          Tích hợp hệ thống với toàn bộ các hãng hàng không, xe lửa và xe khách
          giúp đảm bảo việc đặt chắc chắn có vé
        </Typography>
      </Stack>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Stack
        spacing={pr`4px`}
        textAlign="center"
        alignItems="center"
      >
        <img
          src="https://storage.googleapis.com/goyolo-production/ve-re.png"
          alt="logo"
          className="lazyload"
          style={{
            width: '150px',
          }}
        />
        <Typography variant="body1">Mua vé rẻ nhất</Typography>
        <Typography variant="caption">
          Dễ dàng so sánh để tìm được giá vé rẻ nhất, nhiều ưu đãi khuyến mãi
        </Typography>
      </Stack>
    </Grid>
    <Grid
      item
      xs={0}
      md={2}
    />
    <Grid
      item
      xs={12}
      md={4}
    >
      <Stack
        spacing={pr`4px`}
        textAlign="center"
        alignItems="center"
      >
        <img
          src="https://storage.googleapis.com/goyolo-production/thanh-toan.png"
          alt="logo"
          className="lazyload"
          style={{
            width: '150px',
          }}
        />
        <Typography variant="body1">Thanh toán tiện lợi</Typography>
        <Typography variant="caption">
          Phương thức thanh toán đa dạng, đảm bảo an an toàn với nhiều lựa chọn
          như chuyển khoản ngân hàng, thẻ tín dụng và Internet Banking
        </Typography>
      </Stack>
    </Grid>
    <Grid
      item
      xs={12}
      md={4}
    >
      <Stack
        spacing={pr`4px`}
        textAlign="center"
        alignItems="center"
      >
        <img
          src="https://storage.googleapis.com/goyolo-production/cs-chudao.png"
          alt="logo"
          className="lazyload"
          style={{
            width: '150px',
          }}
        />
        <Typography variant="body1">Chăm sóc chu đáo</Typography>
        <Typography variant="caption">
          Đội ngũ nhân viên sẵn sàng hỗ trợ bạn trong quá trình đặt vé
        </Typography>
      </Stack>
    </Grid>
    <Grid
      item
      xs={0}
      md={2}
    />

  </Grid>
);

export default SectionWhyBookUs;
